import { createClient as createConnectClient } from '@connectrpc/connect'
import { BaseUserMeta, IUserInfo, JsonObject, createClient } from '@liveblocks/client'
import { createRoomContext } from '@liveblocks/react'
import stc from 'string-to-color'

import { AssessmentService } from '@/gen/inventory/v1/assessment_service_pb'

import { sessionTokenInterceptor } from '@/lib/auth/session-token-interceptor'
import { getConnectTransport } from '@/lib/connect/connect-transport'

// Generates a random consistent color for a user based on their connectionId
export const connectionIdToColor = (connectionId: number) => {
  return stc(connectionId.toString())
}

const notesClient = createConnectClient(
  AssessmentService,
  getConnectTransport({
    interceptors: [sessionTokenInterceptor],
  }),
)

export type Presence = JsonObject & {
  color: string
  cursor: {
    x: number
    y: number
  } | null
}

export type UserMeta = BaseUserMeta & {
  info: IUserInfo & {
    email: string
  }
}

const client = createClient<BaseUserMeta>({
  preventUnsavedChanges: true,
  largeMessageStrategy: 'experimental-fallback-to-http',
  authEndpoint: async () => {
    const { token: userToken } = await notesClient.getToken({})
    return {
      token: userToken,
    }
  },
})

export const {
  RoomProvider,
  useMyPresence,
  useStorage,
  useOthers,
  useThreads,
  useMutation,
  useCreateThread,
  useCreateComment,
  useEditThreadMetadata,
  useRoomInfo,
  useRoom,
  useSelf,
  useUpdateMyPresence,
  useUser,
  useIsInsideRoom,
  useStatus,
  useSyncStatus,
} = createRoomContext<Presence, never, UserMeta>(client)
